/**
 * Converts HTML content to plain text
 * If the content is already plain text (no HTML tags), it returns it as-is
 * @param {string} html - HTML string or plain text
 * @returns {string} Plain text version
 */
export function htmlToText(html) {
  if (!html || typeof html !== 'string') {
    return '';
  }

  // Check if content contains HTML tags
  const hasHtmlTags = /<[^>]+>/g.test(html);
  
  // If no HTML tags, return as-is (already plain text)
  if (!hasHtmlTags) {
    return html.trim();
  }

  try {
    // Create a temporary DOM element to parse HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Extract text content
    let text = tempDiv.textContent || tempDiv.innerText || '';

    // Clean up whitespace: replace multiple spaces/newlines/tabs with single space
    // But preserve line breaks for readability
    text = text
      .replace(/\r\n/g, '\n')  // Normalize line breaks
      .replace(/\r/g, '\n')     // Normalize line breaks
      .replace(/\n{3,}/g, '\n\n') // Max 2 consecutive newlines
      .replace(/[ \t]+/g, ' ') // Multiple spaces/tabs to single space
      .trim();

    // Decode common HTML entities if needed
    if (text.includes('&')) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = text;
      text = textarea.value;
    }

    return text;
  } catch (error) {
    console.warn('Error converting HTML to text:', error);
    // Fallback: simple regex-based stripping
    return html
      .replace(/<[^>]+>/g, '') // Remove HTML tags
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
  }
}

/**
 * Truncates text to a specified length with ellipsis
 * @param {string} text - Text to truncate
 * @param {number} maxLength - Maximum length
 * @returns {string} Truncated text
 */
export function truncateText(text, maxLength = 100) {
  if (!text || text.length <= maxLength) {
    return text;
  }
  return text.substring(0, maxLength) + '...';
}

